import AppManagementRequest from './AppManagementRequest';
import { AppData } from './AppManagementModel';
//param @app : AppManagementModel
//param @createdBy: user profile from useIdentify()
//appData : AppData
export default class AppDataUpdateRequest extends AppManagementRequest {
	constructor(app, createdBy, appData = null) {
		super(app, createdBy);
		this.appData = appData ?? new AppData();
	}
}
